export default {
    slug: 'seatplans',
    title: 'Seatplans',
    visible: [
        'title',
    ],
    listview: 'SeatplanListView',
    locales: ['common'],
    columns: [
        {
            key: 'title',
            label: 'Title',
            main: true,
        }
    ],
    actions: {

    }
}


// WEBPACK FOOTER //
// ./src/app/store/seatplans/main/state.js